import React from "react";
import hearts from "../../../assets/images/games/kamasutra/copa.png";
import clubs from "../../../assets/images/games/kamasutra/zap.png";
import spades from "../../../assets/images/games/kamasutra/espada.png";

import heartsGray from "../../../assets/images/games/kamasutra/copa-cinza.png";
import clubsGray from "../../../assets/images/games/kamasutra/zap-cinza.png";
import spadesGray from "../../../assets/images/games/kamasutra/espada-cinza.png";

export default function KamaCardSuit({ suit = "", className = "" }) {
  let image;
  switch (suit) {
    case "hearts":
      image = hearts;
      break;
    case "clubs":
      image = clubs;
      break;
    case "spades":
      image = spades;
      break;
    case "hearts-gray":
      image = heartsGray;
      break;
    case "clubs-gray":
      image = clubsGray;
      break;
    case "spades-gray":
      image = spadesGray;
      break;
    default:
      image = hearts;
  }

  return (
    <img
      className={`object-contain max-w-[unset] ${className}`}
      src={image}
      alt={suit}
    />
  );
}
